import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-register-wrapper',
  templateUrl: './login-register-wrapper.component.html',
  styleUrls: ['./login-register-wrapper.component.scss'],
})
export class LoginRegisterWrapperComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
